(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1742],{

/***/ 840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18132);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75159);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26718);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71033);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3382);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72509);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);











const Breadcrumbs = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 624).then(__webpack_require__.bind(__webpack_require__, 33053)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(33053)]
  }
});
const Autocomplete = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(3344), __webpack_require__.e(3292), __webpack_require__.e(9653), __webpack_require__.e(804), __webpack_require__.e(1521), __webpack_require__.e(6350), __webpack_require__.e(7553)]).then(__webpack_require__.bind(__webpack_require__, 63070)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(63070)]
  }
});

const FaqNltPage = _ref => {
  let {
    faq,
    searchAutoCompleteItems,
    slug
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)();
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  const {
    items,
    title
  } = faq;
  const crumbs = [{
    page: 'Home Page',
    href: '/',
    title: 'Home Page'
  }, {
    page: 'Noleggio a Lungo Termine',
    href: '/noleggio-a-lungo-termine',
    title: 'Noleggio a Lungo Termine'
  }, {
    page: 'FAQ',
    href: '/noleggio-a-lungo-termine/faq',
    title: 'FAQ'
  }, {
    page: title,
    href: router.asPath.split('#')[0],
    title
  }];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
    bgColor: "baseBackgroundLight",
    mt: "-2",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      title: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      meta: t('faqPage:meta', {
        returnObjects: true
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_7__/* .LinkRel */ .M, {
      rel: "canonical",
      href: `https://www.carplanner.com/noleggio-a-lungo-termine/faq/${slug}`
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
      textAlign: "center",
      bg: "primaryGreen.50",
      position: "sticky",
      top: "-xxl2",
      zIndex: "9",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
        maxW: "7xl",
        py: "l",
        mx: "auto",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, {
          display: {
            base: 'none',
            md: 'flex'
          },
          mx: "-1.5rem",
          mt: "-5",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Breadcrumbs, {
            items: crumbs
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, {
          display: {
            base: 'flex',
            md: 'none'
          },
          mx: "m",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(src_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            href: "/noleggio-a-lungo-termine/faq",
            color: "baseDark",
            fontSize: ".875rem",
            title: "Torna all'elenco delle FAQ",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_9__/* .ChevronLeftIcon */ .wy, {}), " FAQ"]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X6, {
          as: "h1",
          fontSize: "2xl",
          fontFamily: "Montserrat-SemiBold",
          color: "baseDark",
          children: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Autocomplete, {
          items: searchAutoCompleteItems.map(item => ({
            label: `${item.q} - ${item.a}`,
            value: `/noleggio-a-lungo-termine/faq/${item.uri}#${item.anchor}`
          })),
          onSelect: selected => router.push(selected),
          placeholder: t('faqPage:placeholder'),
          notFoundText: t('pageHeaderContainer:nothingFound'),
          mt: "l",
          mx: "auto",
          w: "50%",
          minW: "300px"
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
      maxW: "7xl",
      py: "l",
      mx: "auto",
      children: items.map(item => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
        id: item.anchor,
        bg: "baseWhite",
        p: "l",
        my: "s",
        boxShadow: src_themes__WEBPACK_IMPORTED_MODULE_10__/* .theme.shadows.cards */ .r.shadows.cards,
        textAlign: "left",
        scrollMarginTop: "10em",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
          fontFamily: "Montserrat-SemiBold",
          children: item.q
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
          fontFamily: "Montserrat-Medium",
          className: "faq-answer",
          dangerouslySetInnerHTML: {
            __html: item.a
          }
        })]
      }, item.anchor))
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (FaqNltPage);

/***/ }),

/***/ 26718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18132);
/* harmony import */ var src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34755);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const Head = _ref => {
  let {
    title
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("title", {
      children: [title || t('common:header.title'), ' ', "| CarPlanner"]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Regular.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Medium.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-SemiBold.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .image */ .BH
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[0].image */ .qk[0].image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[1].image */ .qk[1].image
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Head);

/***/ }),

/***/ 71033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ LinkRel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const isMetaTag = value => {
  if (!value || typeof value !== 'object') return false;
  const tag = value;
  const hasNameOrProperty = typeof tag.name === 'string' || typeof tag.property === 'string';
  if (!hasNameOrProperty) return false;
  const contentOk = tag.content === undefined || typeof tag.content === 'string';
  const overrideOk = tag.override === undefined || typeof tag.override === 'string';
  return contentOk && overrideOk;
};

const normalizeMeta = meta => {
  if (!meta) return [];

  if (Array.isArray(meta)) {
    return meta.filter(isMetaTag);
  }

  if (isMetaTag(meta)) {
    return [meta];
  }

  if (typeof meta === 'object') {
    return Object.values(meta).filter(isMetaTag);
  }

  return [];
};

const MetaTags = _ref => {
  let {
    meta
  } = _ref;
  const tags = normalizeMeta(meta);
  if (tags.length === 0) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: tags.map((tag, index) => {
      const content = tag.override && tag.override.trim() !== '' ? tag.override : tag.content ?? '';
      const key = tag.name ?? tag.property ?? `meta-${index}`;

      if (tag.name) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          name: tag.name,
          content: content
        }, key);
      }

      if (tag.property) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          property: tag.property,
          content: content
        }, key);
      }

      return null;
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);
const LinkRel = _ref2 => {
  let {
    rel,
    href,
    crossOrigin,
    type,
    as
  } = _ref2;
  let url = '';

  if (rel === 'canonical' && href.indexOf('?') >= 0) {
    // rimuove eventuali parametri querystring
    url = href.split('?')[0] ?? '';
  } else {
    url = href;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: rel,
      href: url,
      crossOrigin: crossOrigin || null,
      type: type || null,
      as: as || null
    })
  });
};

/***/ }),

/***/ 72509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["children", "href", "title", "target", "color", "fontFamily", "fontSize", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const StylesLink = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  componentId: "sc-vy2q48-0"
})(["& svg{display:inline;}"]);

const TextLink = _ref => {
  let {
    children,
    href,
    title,
    target,
    color,
    fontFamily,
    fontSize,
    style
  } = _ref,
      props = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StylesLink, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, _objectSpread(_objectSpread({
      color: color || 'baseWhite',
      title: title,
      target: target || '_self',
      fontFamily: fontFamily ? fontFamily : 'Montserrat-Medium',
      fontSize: fontSize ? fontSize : '1rem',
      letterSpacing: "0.3px",
      display: "inline",
      _hover: {
        textDecoration: 'none'
      }
    }, props), {}, {
      href: href,
      children: children
    }))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TextLink);

/***/ }),

/***/ 63266:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noleggio-a-lungo-termine/faq/[slug]",
      function () {
        return __webpack_require__(840);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 34755:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TN":"Lasciati guidare verso\\nla scelta dell’auto migliore","BH":"https://static1.carplanner.com/website/assets/index-head.jpg","Oc":"CarPlanner ti propone le offerte di auto nuove più competitive\\nsul mercato sia per l’acquisto che per il Noleggio a Lungo Termine","qk":[{"image":"https://static1.carplanner.com/website/assets/noleggia-la-tua-auto-a-lungo-termine-2.png","title":"Noleggia la tua auto a lungo termine","description":"Cerchi un’alternativa all’acquisto di un’auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/noleggio-a-lungo-termine","alt":"Offerte noleggio a lungo termine","target":"_self"},{"image":"https://static1.carplanner.com/website/assets/acquista-la-tua-nuova-auto-online-2.png","title":"Acquista la tua nuova auto online","description":"Cerchi la tua\\nnuova auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/offerte-auto","alt":"Offerte auto in vendita","target":"_self"}],"PX":{"a":"Contattaci ora"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3382,9774,2888,179], function() { return __webpack_exec__(63266); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);